<template>
<kt-span class="kt-nav__link-badge">
    <kt-span class="kt-badge kt-badge--$variant kt-badge--pill" :class="{'kt-badge--inline kt-badge--rounded': is_inline}">
        <slot></slot>
    </kt-span>
</kt-span>
</template>

<script>
export default {
    props: {
        is_inline: {
            type: Boolean,
            default: false,
        }
    }
}
</script>